// extracted by mini-css-extract-plugin
module.exports = {"overlay":"_1sO9U","info_icon":"_31IjB","car_reservation_btn":"_1A906","first_btn":"_2krWF","close_icon":"_3xOqp"};